export const country = {
  "CN": "中国",
  "AD": "安道尔",
  "AE": "阿闻酋",
  "AF": "阿富汗",
  "AG": "安提瓜和巴布达",
  "AI": "安圭拉",
  "AL": "阿尔巴尼亚",
  "AM": "亚美尼亚",
  "AN": "荷属安的列斯",
  "AO": "安哥拉",
  "AQ": "南极洲",
  "AR": "阿根廷",
  "AS": "美属萨摩亚",
  "AT": "奥地利",
  "AU": "澳大利亚",
  "AW": "阿鲁巴",
  "AZ": "阿塞拜疆",
  "BA": "波斯尼亚和黑塞哥维那",
  "BB": "巴巴多斯",
  "BD": "孟加拉国",
  "BE": "比利时",
  "BF": "布基纳法索",
  "BG": "保加利亚",
  "BH": "巴林",
  "BI": "布隆迪",
  "BJ": "贝宁",
  "BL": "聖巴托洛繆島",
  "BM": "百慕大",
  "BN": "文莱",
  "BO": "玻利维亚",
  "BR": "巴西",
  "BS": "巴哈马",
  "BT": "不丹",
  "BW": "博茨瓦纳",
  "BY": "白俄罗斯",
  "BZ": "伯利兹",
  "CA": "加拿大",
  "CC": "科科斯(基林)群岛",
  "CD": "刚果民主共和",
  "CF": "中非",
  "CG": "刚果",
  "CH": "瑞士",
  "CI": "科特迪瓦",
  "CK": "库克群岛",
  "CL": "智利",
  "CM": "喀麦隆",
  "CO": "哥伦比亚",
  "CR": "哥斯达黎加",
  "CU": "古巴",
  "CV": "佛得角",
  "CX": "圣诞岛",
  "CY": "塞浦路斯",
  "CZ": "捷克",
  "DE": "德国",
  "DJ": "吉布提",
  "DK": "丹麦",
  "DM": "多米尼克",
  "DO": "多米尼加共和国",
  "DZ": "阿尔及利亚",
  "EC": "厄瓜多尔",
  "EE": "爱沙尼亚",
  "EG": "埃及",
  "EH": "西撒哈拉",
  "ER": "厄立特里亚",
  "ES": "西班牙",
  "ET": "埃塞俄比亚",
  "FI": "芬兰",
  "FJ": "斐济",
  "FK": "马尔维纳斯群岛(福克兰群岛)",
  "FM": "密克罗尼西亚",
  "FO": "法罗群岛",
  "FR": "法国",
  "GA": "加蓬",
  "GB": "英国",
  "GD": "格林纳达",
  "GE": "格鲁吉亚",
  "GF": "法属圭亚那",
  "GG": "根西岛",
  "GH": "加纳",
  "GI": "直布罗陀",
  "GL": "格陵兰",
  "GM": "冈比亚",
  "GN": "几内亚",
  "GP": "瓜德罗普",
  "GQ": "赤道几内亚",
  "GR": "希腊",
  "GS": "南乔治亚岛和南桑德韦奇岛",
  "GT": "危地马拉",
  "GU": "关岛",
  "GW": "几内亚比绍",
  "GY": "圭亚那",
  "HN": "洪都拉斯",
  "HR": "克罗地亚",
  "HT": "海地",
  "HU": "匈牙利",
  "ID": "印度尼西亚",
  "IE": "爱尔兰",
  "IL": "以色列",
  "IM": "曼島",
  "IN": "印度",
  "IO": "英属印度洋领土",
  "IQ": "伊拉克",
  "IR": "伊朗",
  "IS": "冰岛",
  "IT": "意大利",
  "JE": "澤西島",
  "JM": "牙买加",
  "JO": "约旦",
  "JP": "日本",
  "KE": "肯尼亚",
  "KG": "吉尔吉斯斯坦",
  "KH": "柬埔寨",
  "KI": "基里巴斯",
  "KM": "科摩罗",
  "KN": "圣基茨和尼维斯",
  "KP": "朝鲜",
  "KR": "韩国",
  "KW": "科威特",
  "KY": "开曼群岛",
  "KZ": "哈萨克斯坦",
  "LA": "老挝",
  "LB": "黎巴嫩",
  "LC": "圣卢西亚",
  "LI": "列支敦士登",
  "LK": "斯里兰卡",
  "LR": "利比里亚",
  "LS": "莱索托",
  "LT": "立陶宛",
  "LU": "卢森堡",
  "LV": "拉脱维亚",
  "LY": "利比亚",
  "MA": "摩洛哥",
  "MC": "摩纳哥",
  "MD": "摩尔多瓦",
  "ME": "蒙特內哥羅",
  "MF": "法屬聖馬丁",
  "MG": "马达加斯加",
  "MH": "马绍尔群岛",
  "MK": "马斯顿",
  "ML": "马里",
  "MM": "缅甸",
  "MN": "蒙古",
  "MP": "北马里亚纳",
  "MQ": "马提尼克",
  "MR": "毛里塔尼亚",
  "MS": "蒙特塞拉特",
  "MT": "马耳他",
  "MU": "毛里求斯",
  "MV": "马尔代夫",
  "MW": "马拉维",
  "MX": "墨西哥",
  "MY": "马来西亚",
  "MZ": "莫桑比克",
  "NA": "纳米比亚",
  "NC": "新喀里多尼亚",
  "NE": "尼日尔",
  "NF": "诺福克岛",
  "NG": "尼日利亚",
  "NI": "尼加拉瓜",
  "NL": "荷兰",
  "NO": "挪威",
  "NP": "尼泊尔",
  "NR": "瑙鲁",
  "NU": "纽埃",
  "NZ": "新西兰",
  "OM": "阿曼",
  "PA": "巴拿马",
  "PE": "秘鲁",
  "PF": "法属波利尼西亚",
  "PG": "巴布亚新几内亚",
  "PH": "菲律宾",
  "PK": "巴基斯坦",
  "PL": "波兰",
  "PM": "圣皮埃尔和密克隆",
  "PN": "皮特凯恩群岛",
  "PR": "波多黎各",
  "PS": "巴勒斯坦",
  "PT": "葡萄牙",
  "PW": "贝劳",
  "PY": "巴拉圭",
  "QA": "卡塔尔",
  "RE": "留尼汪",
  "RO": "罗马尼亚",
  "RS": "塞尔维亚",
  "RU": "俄罗斯",
  "RW": "卢旺达",
  "SA": "沙竺阿拉伯",
  "SB": "所罗门群岛",
  "SC": "塞舌尔",
  "SD": "苏丹",
  "SE": "瑞典",
  "SG": "新加坡",
  "SH": "圣赫勒拿",
  "SI": "斯洛文尼亚",
  "SJ": "斯瓦尔巴群岛",
  "SK": "斯洛伐克",
  "SL": "塞拉利昂",
  "SM": "圣马力诺",
  "SN": "塞内加尔",
  "SO": "索马里",
  "SR": "苏里南",
  "ST": "圣多美和普林西比",
  "SV": "萨尔瓦多",
  "SY": "叙利亚",
  "SZ": "斯威士兰",
  "TC": "特克斯科斯群岛",
  "TD": "乍得",
  "TG": "多哥",
  "TH": "泰国",
  "TJ": "塔吉克斯坦",
  "TK": "托克劳",
  "TL": "东帝汶",
  "TM": "土库曼斯坦",
  "TN": "突尼斯",
  "TO": "汤加",
  "TR": "土耳其",
  "TT": "特立尼达和多巴哥",
  "TV": "图瓦卢",
  "TZ": "坦桑尼亚",
  "UA": "乌克兰",
  "UG": "乌干达",
  "US": "美国",
  "UY": "乌拉圭",
  "UZ": "乌兹别克斯坦",
  "VA": "梵蒂冈",
  "VC": "圣文森特和格林纳丁斯",
  "VE": "委内瑞拉",
  "VG": "英属维尔京群岛",
  "VI": "美属维尔京群岛",
  "VN": "越南",
  "VU": "瓦努阿图",
  "WF": "瓦利斯和富图纳群岛",
  "WS": "西萨摩亚",
  "YE": "也门",
  "YT": "马约特",
  "ZA": "南非",
  "ZM": "赞比亚",
  "ZW": "津巴布韦"
};
export const countryArr = [{
    "country_code": "CN",
    "country_zh": "中国"
  },
  {
    "country_code": "AD",
    "country_zh": "安道尔"
  },
  {
    "country_code": "AE",
    "country_zh": "阿闻酋"
  },
  {
    "country_code": "AF",
    "country_zh": "阿富汗"
  },
  {
    "country_code": "AG",
    "country_zh": "安提瓜和巴布达"
  },
  {
    "country_code": "AI",
    "country_zh": "安圭拉"
  },
  {
    "country_code": "AL",
    "country_zh": "阿尔巴尼亚"
  },
  {
    "country_code": "AM",
    "country_zh": "亚美尼亚"
  },
  {
    "country_code": "AN",
    "country_zh": "荷属安的列斯"
  },
  {
    "country_code": "AO",
    "country_zh": "安哥拉"
  },
  {
    "country_code": "AQ",
    "country_zh": "南极洲"
  },
  {
    "country_code": "AR",
    "country_zh": "阿根廷"
  },
  {
    "country_code": "AS",
    "country_zh": "美属萨摩亚"
  },
  {
    "country_code": "AT",
    "country_zh": "奥地利"
  },
  {
    "country_code": "AU",
    "country_zh": "澳大利亚"
  },
  {
    "country_code": "AW",
    "country_zh": "阿鲁巴"
  },
  {
    "country_code": "AZ",
    "country_zh": "阿塞拜疆"
  },
  {
    "country_code": "BA",
    "country_zh": "波斯尼亚和黑塞哥维那"
  },
  {
    "country_code": "BB",
    "country_zh": "巴巴多斯"
  },
  {
    "country_code": "BD",
    "country_zh": "孟加拉国"
  },
  {
    "country_code": "BE",
    "country_zh": "比利时"
  },
  {
    "country_code": "BF",
    "country_zh": "布基纳法索"
  },
  {
    "country_code": "BG",
    "country_zh": "保加利亚"
  },
  {
    "country_code": "BH",
    "country_zh": "巴林"
  },
  {
    "country_code": "BI",
    "country_zh": "布隆迪"
  },
  {
    "country_code": "BJ",
    "country_zh": "贝宁"
  },
  {
    "country_code": "BL",
    "country_zh": "聖巴托洛繆島"
  },
  {
    "country_code": "BM",
    "country_zh": "百慕大"
  },
  {
    "country_code": "BN",
    "country_zh": "文莱"
  },
  {
    "country_code": "BO",
    "country_zh": "玻利维亚"
  },
  {
    "country_code": "BR",
    "country_zh": "巴西"
  },
  {
    "country_code": "BS",
    "country_zh": "巴哈马"
  },
  {
    "country_code": "BT",
    "country_zh": "不丹"
  },
  {
    "country_code": "BW",
    "country_zh": "博茨瓦纳"
  },
  {
    "country_code": "BY",
    "country_zh": "白俄罗斯"
  },
  {
    "country_code": "BZ",
    "country_zh": "伯利兹"
  },
  {
    "country_code": "CA",
    "country_zh": "加拿大"
  },
  {
    "country_code": "CC",
    "country_zh": "科科斯(基林)群岛"
  },
  {
    "country_code": "CD",
    "country_zh": "刚果民主共和"
  },
  {
    "country_code": "CF",
    "country_zh": "中非"
  },
  {
    "country_code": "CG",
    "country_zh": "刚果"
  },
  {
    "country_code": "CH",
    "country_zh": "瑞士"
  },
  {
    "country_code": "CI",
    "country_zh": "科特迪瓦"
  },
  {
    "country_code": "CK",
    "country_zh": "库克群岛"
  },
  {
    "country_code": "CL",
    "country_zh": "智利"
  },
  {
    "country_code": "CM",
    "country_zh": "喀麦隆"
  },
  {
    "country_code": "CO",
    "country_zh": "哥伦比亚"
  },
  {
    "country_code": "CR",
    "country_zh": "哥斯达黎加"
  },
  {
    "country_code": "CU",
    "country_zh": "古巴"
  },
  {
    "country_code": "CV",
    "country_zh": "佛得角"
  },
  {
    "country_code": "CX",
    "country_zh": "圣诞岛"
  },
  {
    "country_code": "CY",
    "country_zh": "塞浦路斯"
  },
  {
    "country_code": "CZ",
    "country_zh": "捷克"
  },
  {
    "country_code": "DE",
    "country_zh": "德国"
  },
  {
    "country_code": "DJ",
    "country_zh": "吉布提"
  },
  {
    "country_code": "DK",
    "country_zh": "丹麦"
  },
  {
    "country_code": "DM",
    "country_zh": "多米尼克"
  },
  {
    "country_code": "DO",
    "country_zh": "多米尼加共和国"
  },
  {
    "country_code": "DZ",
    "country_zh": "阿尔及利亚"
  },
  {
    "country_code": "EC",
    "country_zh": "厄瓜多尔"
  },
  {
    "country_code": "EE",
    "country_zh": "爱沙尼亚"
  },
  {
    "country_code": "EG",
    "country_zh": "埃及"
  },
  {
    "country_code": "EH",
    "country_zh": "西撒哈拉"
  },
  {
    "country_code": "ER",
    "country_zh": "厄立特里亚"
  },
  {
    "country_code": "ES",
    "country_zh": "西班牙"
  },
  {
    "country_code": "ET",
    "country_zh": "埃塞俄比亚"
  },
  {
    "country_code": "FI",
    "country_zh": "芬兰"
  },
  {
    "country_code": "FJ",
    "country_zh": "斐济"
  },
  {
    "country_code": "FK",
    "country_zh": "马尔维纳斯群岛(福克兰群岛)"
  },
  {
    "country_code": "FM",
    "country_zh": "密克罗尼西亚"
  },
  {
    "country_code": "FO",
    "country_zh": "法罗群岛"
  },
  {
    "country_code": "FR",
    "country_zh": "法国"
  },
  {
    "country_code": "GA",
    "country_zh": "加蓬"
  },
  {
    "country_code": "GB",
    "country_zh": "英国"
  },
  {
    "country_code": "GD",
    "country_zh": "格林纳达"
  },
  {
    "country_code": "GE",
    "country_zh": "格鲁吉亚"
  },
  {
    "country_code": "GF",
    "country_zh": "法属圭亚那"
  },
  {
    "country_code": "GG",
    "country_zh": "根西岛"
  },
  {
    "country_code": "GH",
    "country_zh": "加纳"
  },
  {
    "country_code": "GI",
    "country_zh": "直布罗陀"
  },
  {
    "country_code": "GL",
    "country_zh": "格陵兰"
  },
  {
    "country_code": "GM",
    "country_zh": "冈比亚"
  },
  {
    "country_code": "GN",
    "country_zh": "几内亚"
  },
  {
    "country_code": "GP",
    "country_zh": "瓜德罗普"
  },
  {
    "country_code": "GQ",
    "country_zh": "赤道几内亚"
  },
  {
    "country_code": "GR",
    "country_zh": "希腊"
  },
  {
    "country_code": "GS",
    "country_zh": "南乔治亚岛和南桑德韦奇岛"
  },
  {
    "country_code": "GT",
    "country_zh": "危地马拉"
  },
  {
    "country_code": "GU",
    "country_zh": "关岛"
  },
  {
    "country_code": "GW",
    "country_zh": "几内亚比绍"
  },
  {
    "country_code": "GY",
    "country_zh": "圭亚那"
  },
  {
    "country_code": "HN",
    "country_zh": "洪都拉斯"
  },
  {
    "country_code": "HR",
    "country_zh": "克罗地亚"
  },
  {
    "country_code": "HT",
    "country_zh": "海地"
  },
  {
    "country_code": "HU",
    "country_zh": "匈牙利"
  },
  {
    "country_code": "ID",
    "country_zh": "印度尼西亚"
  },
  {
    "country_code": "IE",
    "country_zh": "爱尔兰"
  },
  {
    "country_code": "IL",
    "country_zh": "以色列"
  },
  {
    "country_code": "IM",
    "country_zh": "曼島"
  },
  {
    "country_code": "IN",
    "country_zh": "印度"
  },
  {
    "country_code": "IO",
    "country_zh": "英属印度洋领土"
  },
  {
    "country_code": "IQ",
    "country_zh": "伊拉克"
  },
  {
    "country_code": "IR",
    "country_zh": "伊朗"
  },
  {
    "country_code": "IS",
    "country_zh": "冰岛"
  },
  {
    "country_code": "IT",
    "country_zh": "意大利"
  },
  {
    "country_code": "JE",
    "country_zh": "澤西島"
  },
  {
    "country_code": "JM",
    "country_zh": "牙买加"
  },
  {
    "country_code": "JO",
    "country_zh": "约旦"
  },
  {
    "country_code": "JP",
    "country_zh": "日本"
  },
  {
    "country_code": "KE",
    "country_zh": "肯尼亚"
  },
  {
    "country_code": "KG",
    "country_zh": "吉尔吉斯斯坦"
  },
  {
    "country_code": "KH",
    "country_zh": "柬埔寨"
  },
  {
    "country_code": "KI",
    "country_zh": "基里巴斯"
  },
  {
    "country_code": "KM",
    "country_zh": "科摩罗"
  },
  {
    "country_code": "KN",
    "country_zh": "圣基茨和尼维斯"
  },
  {
    "country_code": "KP",
    "country_zh": "朝鲜"
  },
  {
    "country_code": "KR",
    "country_zh": "韩国"
  },
  {
    "country_code": "KW",
    "country_zh": "科威特"
  },
  {
    "country_code": "KY",
    "country_zh": "开曼群岛"
  },
  {
    "country_code": "KZ",
    "country_zh": "哈萨克斯坦"
  },
  {
    "country_code": "LA",
    "country_zh": "老挝"
  },
  {
    "country_code": "LB",
    "country_zh": "黎巴嫩"
  },
  {
    "country_code": "LC",
    "country_zh": "圣卢西亚"
  },
  {
    "country_code": "LI",
    "country_zh": "列支敦士登"
  },
  {
    "country_code": "LK",
    "country_zh": "斯里兰卡"
  },
  {
    "country_code": "LR",
    "country_zh": "利比里亚"
  },
  {
    "country_code": "LS",
    "country_zh": "莱索托"
  },
  {
    "country_code": "LT",
    "country_zh": "立陶宛"
  },
  {
    "country_code": "LU",
    "country_zh": "卢森堡"
  },
  {
    "country_code": "LV",
    "country_zh": "拉脱维亚"
  },
  {
    "country_code": "LY",
    "country_zh": "利比亚"
  },
  {
    "country_code": "MA",
    "country_zh": "摩洛哥"
  },
  {
    "country_code": "MC",
    "country_zh": "摩纳哥"
  },
  {
    "country_code": "MD",
    "country_zh": "摩尔多瓦"
  },
  {
    "country_code": "ME",
    "country_zh": "蒙特內哥羅"
  },
  {
    "country_code": "MF",
    "country_zh": "法屬聖馬丁"
  },
  {
    "country_code": "MG",
    "country_zh": "马达加斯加"
  },
  {
    "country_code": "MH",
    "country_zh": "马绍尔群岛"
  },
  {
    "country_code": "MK",
    "country_zh": "马斯顿"
  },
  {
    "country_code": "ML",
    "country_zh": "马里"
  },
  {
    "country_code": "MM",
    "country_zh": "缅甸"
  },
  {
    "country_code": "MN",
    "country_zh": "蒙古"
  },
  {
    "country_code": "MP",
    "country_zh": "北马里亚纳"
  },
  {
    "country_code": "MQ",
    "country_zh": "马提尼克"
  },
  {
    "country_code": "MR",
    "country_zh": "毛里塔尼亚"
  },
  {
    "country_code": "MS",
    "country_zh": "蒙特塞拉特"
  },
  {
    "country_code": "MT",
    "country_zh": "马耳他"
  },
  {
    "country_code": "MU",
    "country_zh": "毛里求斯"
  },
  {
    "country_code": "MV",
    "country_zh": "马尔代夫"
  },
  {
    "country_code": "MW",
    "country_zh": "马拉维"
  },
  {
    "country_code": "MX",
    "country_zh": "墨西哥"
  },
  {
    "country_code": "MY",
    "country_zh": "马来西亚"
  },
  {
    "country_code": "MZ",
    "country_zh": "莫桑比克"
  },
  {
    "country_code": "NA",
    "country_zh": "纳米比亚"
  },
  {
    "country_code": "NC",
    "country_zh": "新喀里多尼亚"
  },
  {
    "country_code": "NE",
    "country_zh": "尼日尔"
  },
  {
    "country_code": "NF",
    "country_zh": "诺福克岛"
  },
  {
    "country_code": "NG",
    "country_zh": "尼日利亚"
  },
  {
    "country_code": "NI",
    "country_zh": "尼加拉瓜"
  },
  {
    "country_code": "NL",
    "country_zh": "荷兰"
  },
  {
    "country_code": "NO",
    "country_zh": "挪威"
  },
  {
    "country_code": "NP",
    "country_zh": "尼泊尔"
  },
  {
    "country_code": "NR",
    "country_zh": "瑙鲁"
  },
  {
    "country_code": "NU",
    "country_zh": "纽埃"
  },
  {
    "country_code": "NZ",
    "country_zh": "新西兰"
  },
  {
    "country_code": "OM",
    "country_zh": "阿曼"
  },
  {
    "country_code": "PA",
    "country_zh": "巴拿马"
  },
  {
    "country_code": "PE",
    "country_zh": "秘鲁"
  },
  {
    "country_code": "PF",
    "country_zh": "法属波利尼西亚"
  },
  {
    "country_code": "PG",
    "country_zh": "巴布亚新几内亚"
  },
  {
    "country_code": "PH",
    "country_zh": "菲律宾"
  },
  {
    "country_code": "PK",
    "country_zh": "巴基斯坦"
  },
  {
    "country_code": "PL",
    "country_zh": "波兰"
  },
  {
    "country_code": "PM",
    "country_zh": "圣皮埃尔和密克隆"
  },
  {
    "country_code": "PN",
    "country_zh": "皮特凯恩群岛"
  },
  {
    "country_code": "PR",
    "country_zh": "波多黎各"
  },
  {
    "country_code": "PS",
    "country_zh": "巴勒斯坦"
  },
  {
    "country_code": "PT",
    "country_zh": "葡萄牙"
  },
  {
    "country_code": "PW",
    "country_zh": "贝劳"
  },
  {
    "country_code": "PY",
    "country_zh": "巴拉圭"
  },
  {
    "country_code": "QA",
    "country_zh": "卡塔尔"
  },
  {
    "country_code": "RE",
    "country_zh": "留尼汪"
  },
  {
    "country_code": "RO",
    "country_zh": "罗马尼亚"
  },
  {
    "country_code": "RS",
    "country_zh": "塞尔维亚"
  },
  {
    "country_code": "RU",
    "country_zh": "俄罗斯"
  },
  {
    "country_code": "RW",
    "country_zh": "卢旺达"
  },
  {
    "country_code": "SA",
    "country_zh": "沙竺阿拉伯"
  },
  {
    "country_code": "SB",
    "country_zh": "所罗门群岛"
  },
  {
    "country_code": "SC",
    "country_zh": "塞舌尔"
  },
  {
    "country_code": "SD",
    "country_zh": "苏丹"
  },
  {
    "country_code": "SE",
    "country_zh": "瑞典"
  },
  {
    "country_code": "SG",
    "country_zh": "新加坡"
  },
  {
    "country_code": "SH",
    "country_zh": "圣赫勒拿"
  },
  {
    "country_code": "SI",
    "country_zh": "斯洛文尼亚"
  },
  {
    "country_code": "SJ",
    "country_zh": "斯瓦尔巴群岛"
  },
  {
    "country_code": "SK",
    "country_zh": "斯洛伐克"
  },
  {
    "country_code": "SL",
    "country_zh": "塞拉利昂"
  },
  {
    "country_code": "SM",
    "country_zh": "圣马力诺"
  },
  {
    "country_code": "SN",
    "country_zh": "塞内加尔"
  },
  {
    "country_code": "SO",
    "country_zh": "索马里"
  },
  {
    "country_code": "SR",
    "country_zh": "苏里南"
  },
  {
    "country_code": "ST",
    "country_zh": "圣多美和普林西比"
  },
  {
    "country_code": "SV",
    "country_zh": "萨尔瓦多"
  },
  {
    "country_code": "SY",
    "country_zh": "叙利亚"
  },
  {
    "country_code": "SZ",
    "country_zh": "斯威士兰"
  },
  {
    "country_code": "TC",
    "country_zh": "特克斯科斯群岛"
  },
  {
    "country_code": "TD",
    "country_zh": "乍得"
  },
  {
    "country_code": "TG",
    "country_zh": "多哥"
  },
  {
    "country_code": "TH",
    "country_zh": "泰国"
  },
  {
    "country_code": "TJ",
    "country_zh": "塔吉克斯坦"
  },
  {
    "country_code": "TK",
    "country_zh": "托克劳"
  },
  {
    "country_code": "TL",
    "country_zh": "东帝汶"
  },
  {
    "country_code": "TM",
    "country_zh": "土库曼斯坦"
  },
  {
    "country_code": "TN",
    "country_zh": "突尼斯"
  },
  {
    "country_code": "TO",
    "country_zh": "汤加"
  },
  {
    "country_code": "TR",
    "country_zh": "土耳其"
  },
  {
    "country_code": "TT",
    "country_zh": "特立尼达和多巴哥"
  },
  {
    "country_code": "TV",
    "country_zh": "图瓦卢"
  },
  {
    "country_code": "TZ",
    "country_zh": "坦桑尼亚"
  },
  {
    "country_code": "UA",
    "country_zh": "乌克兰"
  },
  {
    "country_code": "UG",
    "country_zh": "乌干达"
  },
  {
    "country_code": "US",
    "country_zh": "美国"
  },
  {
    "country_code": "UY",
    "country_zh": "乌拉圭"
  },
  {
    "country_code": "UZ",
    "country_zh": "乌兹别克斯坦"
  },
  {
    "country_code": "VA",
    "country_zh": "梵蒂冈"
  },
  {
    "country_code": "VC",
    "country_zh": "圣文森特和格林纳丁斯"
  },
  {
    "country_code": "VE",
    "country_zh": "委内瑞拉"
  },
  {
    "country_code": "VG",
    "country_zh": "英属维尔京群岛"
  },
  {
    "country_code": "VI",
    "country_zh": "美属维尔京群岛"
  },
  {
    "country_code": "VN",
    "country_zh": "越南"
  },
  {
    "country_code": "VU",
    "country_zh": "瓦努阿图"
  },
  {
    "country_code": "WF",
    "country_zh": "瓦利斯和富图纳群岛"
  },
  {
    "country_code": "WS",
    "country_zh": "西萨摩亚"
  },
  {
    "country_code": "YE",
    "country_zh": "也门"
  },
  {
    "country_code": "YT",
    "country_zh": "马约特"
  },
  {
    "country_code": "ZA",
    "country_zh": "南非"
  },
  {
    "country_code": "ZM",
    "country_zh": "赞比亚"
  },
  {
    "country_code": "ZW",
    "country_zh": "津巴布韦"
  }
];